import React from 'react'

const Container = ({children, fluid, section, extraClassName, className, style}) => {
  let containerClass = [className || 'ncss-container']
  if (extraClassName) containerClass.push(extraClassName)
  if (fluid) containerClass.push('fixed-fluid')
  if (section) containerClass.push('bg-white border p6-sm mb5-sm')

  return (
    <div className={containerClass.join(' ')} style={style}>{children}</div>
  )
}

export default Container



// WEBPACK FOOTER //
// ./client/src/components/ncss/Container.js